export default __webpack_public_path__ + "static/media/sick-day-icon.2b099e37.svg";